import * as React from "react";
import { forwardRef } from "react";
const SvgRestart = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.5 9.97585C17.5 13.4374 14.6154 17.4758 10 17.4758C5.38462 17.4758 2.5 13.4374 2.5 9.97585C2.5 6.51431 5.38462 2.47585 10 2.47585C12.8846 2.47585 15.1923 4.20662 16.3462 5.93739M16.3462 5.93739L12.3077 6.51431M16.3462 5.93739L16.9231 1.89893", stroke: "#1A2023", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgRestart);
export { ForwardRef as ReactComponent };
